// extracted by mini-css-extract-plugin
module.exports = {"section-header":"section-header"};